import Vue from 'vue';
import Vuex from 'vuex';
import pay from './modules/pay';
import order from './modules/order';
import member from './modules/member';
import cart from './modules/cart';
import couponState from './modules/coupon';
import redeem from './modules/redeem';
import address from './modules/address';
import skinTestCoupon from './modules/skin-test-coupon';
import systemPop from './modules/system-popup';
import { soyoungWxAuthGetWxSessionInfo, checkCustomerEnable } from '@/api/wechat';
import eventReporter from '@/utils/event-reporter';
import { memberUpdate, memberLevelConfigListForApp } from '@/api/shopmember';
import { agreeAgreementNotice } from '@/api/marketing';
import memberUtils from '@/utils/memberUtils';
import fetch from '@/utils/fetch';
import dayjs from 'dayjs';
import { getShopBasicInfo } from '@/api/configure';
import config from '@/config/index.js';
import { RESET_CART_STORE, SET_LOGOUT_STATE } from '@/vuex/mutations-types';
import sensors from '@/js_sdk/Sensorsdata-UniPlugin-JS/Sensorsdata-UniPlugin-JS/index';
import PromoteHandle, { getMyPromoter } from '@/models/promote/PromoteHandle';

import freeLoginActive from './modules/free-login-active';

import alipayVouchers from '@/vuex/modules/alipay-vouchers';

Vue.use(Vuex);

let lifeData = {};
const promoteHandle = new PromoteHandle();
try {
  // 尝试获取本地是否存在lifeData变量，第一次启动APP时是不存在的
  lifeData = uni.getStorageSync('lifeData') || {};
} catch (e) {}

// 需要永久存储，且下次APP启动需要取出的，在state中的变量名
const saveStateKeys = [
  'alipayUserId',
  'token',
  'loginTime',
  'openId',
  'unionId',
  'memberCO',
  'creditName',
  'memberInfo',
  'memberLevelList',
  'shopInfo',
  'promoter',
  'promoterUrl',
  'promoterQiYe',
  'promoterExpireTime',
  'reporterInfo',
  'utm',
  'mpWeixinCpsData',
];
// 保存变量到本地存储中
const saveLifeData = function(key, value) {
  // 判断变量名是否在需要存储的数组中
  if (saveStateKeys.indexOf(key) !== -1) {
    // 获取本地存储的lifeData对象，将变量添加到对象中
    let tmp = JSON.parse(JSON.stringify(lifeData));
    // 如果getStorageSync 失败，再调起一次做下保险
    // try {
    //   tmp = uni.getStorageSync('lifeData');
    // } catch (e) {
    //   tmp = uni.getStorageSync('lifeData');
    // }
    // 第一次打开APP，不存在lifeData变量，故放一个{}空对象
    tmp = tmp || {};
    tmp[key] = value;
    // 执行这一步后，所有需要存储的变量，都挂载在本地的lifeData对象中
    // uni.setStorageSync('lifeData', tmp);
    lifeData = tmp;
    uni.setStorage({
      key: 'lifeData',
      data: tmp,
    });
  }
};

const store = new Vuex.Store({
  state: {
    currentTabs: '', // 当前分类页的tab
    promoter: '', // 推广员ID
    promoterQiYe: '', // 推广员ID
    promoterExpireTime: '', // 推广员失效时间
    relationshipType: '', // 绑定关系类型
    // 如果上面从本地获取的lifeData对象下有对应的属性，就赋值给state中对应的变量
    systemInfo: '',
    authCode: '', // 微信小程序或支付宝小程序获的authCode,可以用来换微信的openId或支付宝的userId
    alipayUserId: lifeData.alipayUserId || '', // 支付宝userId
    token: lifeData.token || '', // token
    loginTime: lifeData.loginTime || '', // 登录时间
    openId: lifeData.openId || '', // openId
    unionId: lifeData.unionId || '', // unionId
    creditName: lifeData.creditName || '', // 币的名称，不同店铺币的名称不一样，例如水羊币、花币等
    memberInfo: lifeData.memberInfo || '', // memberInfo
    memberCO: lifeData.memberCO || {
      id: '', // memberId
      mobile: '', // 用户手机号码
      nickName: '', // 用户昵称
      icon: '', // 用户头像
      birthday: '', // 生日
      sex: '', // 性别 1：男 2：女
      city: '', // 城市
      province: '', // 省份
    },
    memberLevelList: lifeData.memberLevelList || [], // 会员等级配置信息
    shopInfo: lifeData.shopInfo || {
      id: '',
      name: '', // 店铺名字
      icon: '', // 店铺头像
    }, // 店铺信息
    isRisk: false,
    reporterInfo: lifeData.reporterInfo || {
      para: {},
      props: {},
    },
    utm: lifeData.utm || {},
    mpWeixinCpsData: lifeData.mpWeixinCpsData || { syAdChannel: '', expireTime: '', content: '' }, // 微信小程序cps参数
    scene: null, // 启动小程序的场景值
    customerIsEnable: '0', // 是否启用微信客服，默认不启用
    pageNavChangeOpacity: {}, // navbar滚动透明度 用于导航条滚动样式变化判断
  },
  getters: {
    isLogin: state => Boolean(state.token),
    systemInfo: state => state.systemInfo,
    skinTestIsPrefixLogin: state => state.skinTestCoupon.survey.enableLoginType === 'PREFIX_LOGIN',
    customerFlag: state => state.customerIsEnable || uni.getStorageSync('customerIsEnable'),
    memberLevelList: state => state.memberLevelList,
  },
  mutations: {
    $uStore(state, payload) {
      // 判断是否多层级调用，state中为对象存在的情况，诸如user.info.score = 1
      const nameArr = payload.name.split('.');
      let saveKey = '';
      const len = nameArr.length;
      if (nameArr.length >= 2) {
        let obj = state[nameArr[0]];
        for (let i = 1; i < len - 1; i++) {
          obj = obj[nameArr[i]];
        }
        obj[nameArr[len - 1]] = payload.value;
        saveKey = nameArr[0];
      } else {
        // 单层级变量，在state就是一个普通变量的情况
        state[payload.name] = payload.value;
        saveKey = payload.name;
      }
      // 保存变量到本地，见顶部函数定义
      saveLifeData(saveKey, state[saveKey]);
    },
  },
  actions: {
    getShopInfo({ commit }) {
      return new Promise((resolve, reject) => {
        const id = config.EXT_TENANT_ID;
        if (!id) {
          reject('EXT_TENANT_ID 为空');
        }
        getShopBasicInfo(id).then(
          data => {
            if (data.success) {
              const { id, icon, name } = data.data;
              commit('$uStore', {
                name: 'shopInfo',
                value: { id, icon, name },
              });
            } else {
              reject(data);
            }
          },
          err => {
            reject(err);
          }
        );
      });
    },
    /*
      isFetch 是否调用jsapi强制获取
     */
    getSystemInfo({ commit, state }, isFetch = false) {
      return new Promise((resolve, reject) => {
        if (!isFetch && state.systemInfo) {
          resolve(state.systemInfo);
        }
        uni.getSystemInfo({
          success: res => {
            commit('$uStore', {
              name: 'systemInfo',
              value: res,
            });
            resolve(res);
          },
          fail: err => {
            reject(err);
          },
        });
      });
    },
    // 微信小程序和支付宝小程序获取authCode,可以用来换微信的openId和支付宝的userId
    getAuthCode({ commit }) {
      return new Promise((resolve, reject) => {



























































      });
    },
    fetchOpenId({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('getAuthCode').then(authCode => {
          soyoungWxAuthGetWxSessionInfo(authCode).then(
            res => {
              commit('$uStore', {
                name: 'authCode',
                value: '',
              });
              if (res.success && res.data) {
                const { openid, unionid } = res.data;
                commit('$uStore', {
                  name: 'openId',
                  value: openid,
                });
                commit('$uStore', {
                  name: 'unionId',
                  value: unionid,
                });
                //* 设置事件上报的openId
                eventReporter.setOpenId(openid);
                resolve(res.data);
              } else {
                resolve(res);
              }
            },
            err => {
              commit('$uStore', {
                name: 'authCode',
                value: '',
              });
              reject(err);
            }
          );
        });
      });
    },
    getPesonalCenterInfo({ commit }) {
      return new Promise((resolve, reject) => {
        fetch.get('/shopmember/api/member/getInfo').then(
          res => {
            let { success, data = {} } = res;
            if (!success) return reject(res);



            data.birthday = data.birthday ? dayjs(data.birthday).format('YYYY-MM-DD') : '';
            const { creditInfoVO = {} } = data;
            if (!creditInfoVO.creditRuleName) {
              creditInfoVO.creditRuleName = '水羊币';
            }
            commit('$uStore', {
              name: 'creditName',
              value: creditInfoVO.creditRuleName,
            });
            commit('$uStore', {
              name: 'memberInfo',
              value: data,
            });
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    logout({ commit }) {
      eventReporter.logout();
      uni.removeStorageSync('mysteryData');
      wx.removeStorageSync('vipMemberCardInfo');
      wx.removeStorageSync('unionId');
      commit('$uStore', {
        name: 'token',
        value: '',
      });
      commit('$uStore', {
        name: 'openId',
        value: '',
      });
      commit('$uStore', {
        name: 'alipayUserId',
        value: '',
      });
      commit('$uStore', {
        name: 'memberCO',
        value: '',
      });
      commit('$uStore', {
        name: 'memberInfo',
        value: '',
      });
      commit(RESET_CART_STORE);
      commit(SET_LOGOUT_STATE, !couponState.state.logout);
      wx.removeStorageSync('creditName');
      wx.removeStorageSync('promote-rel');
      wx.removeStorageSync('creditRuleObj');
      wx.removeStorageSync('keyWord');
      wx.removeStorageSync('event-report-list');
      wx.removeStorageSync('memberHomeBackCredit');
      // v3.3.0 清理促销员相关(个人，企业)
      // store.commit('$uStore', { name: 'promoter', value: '' });
      // store.commit('$uStore', { name: 'promoterExpireTime', value: '' });
      // store.commit('$uStore', { name: 'promoterQiYe', value: '' });
    },
    // 这里不要加async
    handleLoginSuccess({ commit, dispatch }, loginData) {
      const { alipayVO, method } = loginData;










      if (loginData.openId) {
        commit('$uStore', {
          name: 'openId',
          value: loginData.openId,
        });
      }

      if (loginData.unionId) {
        commit('$uStore', {
          name: 'unionId',
          value: loginData.unionId,
        });
      }

      // 数据完整，走正常流程
      const { memberCO, user } = loginData;
      const { userToken } = user;
      commit('$uStore', {
        name: 'token',
        value: userToken,
      });
      commit('$uStore', {
        name: 'loginTime',
        value: Date.parse(new Date()),
      });
      if (memberCO && memberCO.id) {
        // 事件上报传入memberId
        eventReporter.login(memberCO.id, memberCO.mobile);
        sensors.login(memberCO.id);
        eventReporter.track('LOGIN', { method });
      }
      const { id, icon, sex, nickName } = memberCO;
      // // 没有绑定微信情况下，如果没头像给用户更新一个默认的
      if (!icon) {
        memberCO.icon =
          'https://image.syounggroup.com/newretail/mobile/images/account/default-avatar.png';
      }
      memberUpdate({
        id,
        nickName,
        icon: memberCO.icon,
        sex,
      });
      commit('$uStore', {
        name: 'memberCO',
        value: memberCO,
      });
      memberUtils.memberSourceCreateRequest();
      // 登陆即同意用户协议
      const memberId = store.state.memberCO.id;
      if (memberId) {
        agreeAgreementNotice().then(res => {
          if (res.code === '0') {
          } else {
            alert(res.msg);
          }
        });
      } else {
        alert(memberId);
      }
      // v2.22.3 促销员 start
      const promoter = store.state.promoter;
      const type = store.state.relationshipType;
      console.log('promoterpromoterpromoter');
      console.log(promoter);
      if (promoter) {
        // 埋点 start
        const reportData = { promoter: promoter, eventType: 'LOGIN_BINDING' };
        eventReporter.trackPromoterEvent(reportData);
        // 埋点 end
        const promoterUrl = store.state.promoterUrl;
        promoteHandle.bindPromoter(promoter, promoterUrl, type);
      } else {
        // v3.3.0
        // doBingdingNewUser();
      }
      // v2.22.3 促销员 end
      getMyPromoter();
      dispatch('relationshipSurveyMember'); // 匿名问卷关联用户




    },
    checkCustomerType({ commit }) {
      checkCustomerEnable().then(res => {
        if (res.success && res.data) {
          const customerIsEnable = res.data.isEnable || '0';
          uni.setStorage({
            key: 'customerIsEnable',
            data: customerIsEnable + '',
          });
          commit('$uStore', {
            name: 'customerIsEnable',
            value: customerIsEnable + '',
          });
        }
      });
    },
    // 获取会员配置信息
    async getMemberLevelList({ commit }) {
      const { data = [] } = await memberLevelConfigListForApp();
      commit('$uStore', {
        name: 'memberLevelList',
        value: data,
      });
    },
  },
  modules: {
    vuexPay: pay,
    vuexOrder: order,
    member,
    vuexCart: cart,
    couponState,
    redeem,
    systemPop,
    alipayVouchers,
    skinTestCoupon,
    address,

    freeLoginActive,

  },
});
Vue.prototype.$setVuex = (name, value) => {
  store.commit('$uStore', {
    name,
    value,
  });
};
export default store;
